// 合同审核页面
<template>
  <div class="root-contrast">
    <!-- title -->
    <route-name propsRouteName="法律风险审核"></route-name>
    <!-- content 内容 -->
    <div class="content">
      <!-- 选择合同 -->
      <div class="choose-doc">
        <p>1.选择合同领域</p>
        <p style="margin: 10px 0">根据提示信息完善表格内容，请勿缺少信息</p>
        <el-form :model="form" inline size="small" ref="typeForm">
          <el-form-item
            label="合同领域:"
            prop="fieId"
            :rules="{
              required: true,
              message: '请选择合同领域',
              trigger: 'blur',
            }"
          >
            <el-select
              v-model="form.fieId"
              clearable
              placeholder="请选择合同领域"
              @change="typeChange"
            >
              <el-option
                v-for="item of examineTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="合同规则:"
            prop="ruleId"
            :rules="{
              required: true,
              message: '请选择审核规则',
              trigger: 'blur',
            }"
          >
            <el-select
              v-model="form.ruleId"
              placeholder="请选择审核规则"
              @change="rulesChange"
            >
              <el-option
                v-for="item of examRules"
                :key="Object.values(item)[0]"
                :label="Object.keys(item)[0]"
                :value="Object.values(item)[0]"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <!-- 上传合同 -->
      <div class="examine">
        <div class="upload-box">
          <p style="color: #222">上传合同：</p>
          <div class="upload">
            <img
              src="/images/AISmart/icon/group.png"
              width="49px"
              height="47px"
              alt=""
            />
            <el-upload
              ref="exUpload"
              class="upload-bth"
              action="#"
              :limit="1"
              :auto-upload="false"
              :on-exceed="exceed"
              accept=".doc,.docx"
              :on-change="changeTarget"
              :before-upload="fileUpBefore"
            >
              <el-button size="small" type="danger" plain>选择文件</el-button>
            </el-upload>
            <span style="color: #999; margin-top: 10px"
              >可支持 .doc、.docx 格式文件，上传单个文件大小不超过30M。</span
            >
          </div>
        </div>
        <div>
          <el-button type="danger" @click="extract" :loading="loading"
            >提交审核</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteName from "@/components/route-name";
// 接口
import {
  ApiMethods,
  postFileTempUpload
} from "../../../assets/js/http-serve/http-methods";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  data () {
    return {
      smartAPI: ApiMethods.AIDocSmart,
      loading: false,
      form: { fieId: "", fieName: "", ruleId: "", ruleName: "" },
      exFile: [],
      // 审核类型列表
      examineTypes: [],
      // 审核类型的规则列表
      examRules: []
    };
  },
  // data end
  methods: {
    async extract () {
      this.$refs.typeForm.validate(vaild => {
        if (vaild) {
          let { form, exFile } = this,
            FD = new FormData();
          if (exFile.length === 0)
            return this.$message.warning("请先上传需要被审核的文档");
          this.loading = true;
          FD.append("category", form.fieName);
          FD.append("categoryId", form.fieId);
          FD.append("rule", form.ruleName);
          FD.append("ruleId", form.ruleId);
          FD.append("targetStoreId", exFile[0].targetId);
          FD.append("fileType", exFile[0].fileType);
          this.smartAPI
            .audit(FD)
            .then(res => {
              if (res.success) {
                this.exFile = [];
                this.$router.push("/smartDoc/docExamine/examineList");
              } else {
                if (res.code == 10807) {
                  this.buyPackge();
                  return;
                }
                this.$message.error(res.description);
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    rulesChange (val) {
      this.examRules.forEach(item => {
        let keys = Object.keys(item);
        if (item[keys[0]] === val) this.form.ruleName = keys[0];
        return;
      });
    },
    typeChange (id) {
      this.smartAPI.examineRules({ categoryId: id }).then(res => {
        if (res.success) {
          this.examRules = res.data;
          this.examineTypes.forEach(item => {
            if (item.id === id) this.form.fieName = item.name;
            return;
          });
        } else {
          this.$message.error(res.description);
        }
      });
    },
    // 审核类型列表查询
    categoryQuery () {
      this.smartAPI.categoryList().then(res => {
        if (res.success) {
          this.examineTypes = res.data;
        } else {
          this.$message.error(res.description);
        }
      });
    },
    exceed (files, fileList) {
      this.$message.warning("仅支持单文件上传,请删除后重新上传");
    },
    changeTarget (file, fileList) {
      if (file.status === "ready") {
        const isLt30M = file.size / 1024 / 1024 < 30,
          re = new RegExp("(.doc|.docx)$", "i");
        if (!isLt30M) return this.$message.error("上传文件大小不能超过 30MB!");
        if (!re.test(file.name)) {
          this.$message.error("文件格式只能是 doc / docx 文件");
          return false;
        }
        this.$refs.exUpload.submit();
      }
    },
    // 文件上传
    fileUpBefore (file) {
      postFileTempUpload({ file, fileType: 1 })
        .then(data => {
          this.exFile[0] = data;
        })
        .catch(err => {
          this.$message.warning(err.description || "上传文件失败");
        });
    },
    // 购买套餐
    buyPackge () {
      // 套餐次数不足 显示购买弹窗
      this.$confirm("当前无文档审核功能使用次数，请前往购买！", "提示", {
        type: "error"
      })
        .then(res => {
          const url = this.globalConfig.domain.accountWeb + "/asset/aiContractChargePage"
          isInDingTalk ? location.href = url : window.open(url);
        })
        .catch(err => {
          // this.$message.error("err", err);
        });
    }
  },
  // methods end
  components: { RouteName },
  created () {
    this.categoryQuery();
  }
};
</script>

<style scoped lang="less">
.root-contrast {
  height: 100%;
  background-color: #fff;
  .content {
    height: calc(85vh - 36px);
    padding: 16px;
    overflow: auto;
    .choose-doc {
      width: 100%;
      padding: 20px;
      background-color: #efefef;
    }
    .examine {
      width: 100%;
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .upload-box {
        width: 100%;
        height: 420px;
        padding: 10px 0 0 24px;
        background-color: #efefef;
        border-radius: 2px 2px 2px 2px;
        overflow: auto;
        > p {
          margin-bottom: 15px;
        }
        .upload {
          width: 98%;
          height: 340px;
          padding: 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: #ffffff;
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #d9d9d9;
          > img {
            margin-bottom: 10px;
          }
          .upload-bth {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
          }
        }
      }
      > div:last-child {
        margin-top: 30px;
      }
    }
  }
}
/deep/.el-upload-list__item-name {
  width: 15vw;
}
</style>



// WEBPACK FOOTER //
// pages/smartDoc/docExamine/examine.vue